import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Zoltrate10mg() {
  const [quantity, setQuantity] = useState(1);
  const [cartCount, setCartCount] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState('180pills');
  const [showAddedMessage, setShowAddedMessage] = useState(false);

  const product = {
    id: 7,
    name: 'Zoltrate 10mg',
    category: 'Sleep Aid',
    price: 540.00,
    image: 'https://public.readdy.ai/ai/img_res/d81de61fa43c6c1b08eefab6da2e9023.jpg',
    rating: 4.6,
    reviews: 198,
    inStock: true,
    description: 'Zoltrate 10mg is a sedative-hypnotic medication used for the short-term treatment of insomnia. It helps you fall asleep faster and stay asleep longer, providing restful sleep for better daily functioning.',
    activeIngredient: 'Zolpidem 10mg',
    manufacturer: 'US Pharmaceutical',
    dosage: '10mg tablets',
    packaging: 'US to US Shipping'
  };

  const packages = {
    '180pills': { pills: 180, price: 540 },
    '360pills': { pills: 360, price: 1050 },
    '540pills': { pills: 540, price: 1550 }
  };

  const currentPackage = packages[selectedPackage as keyof typeof packages];

  useEffect(() => {
    const updateCartCount = () => {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) {
        try {
          const cart = JSON.parse(savedCart);
          const count = cart.reduce((sum: number, item: any) => sum + item.quantity, 0);
          setCartCount(count);
        } catch (error) {
          console.error('Error parsing cart data:', error);
          setCartCount(0);
        }
      }
    };
    
    updateCartCount();
    window.addEventListener('storage', updateCartCount);
    return () => window.removeEventListener('storage', updateCartCount);
  }, []);

  const addToCart = () => {
    const savedCart = localStorage.getItem('cart');
    const cart = savedCart ? JSON.parse(savedCart) : [];
    
    const cartProduct = {
      ...product,
      price: currentPackage.price,
      packageSize: currentPackage.pills,
      packageType: selectedPackage,
      prescriptionRequired: false
    };
    
    const existingItem = cart.find((item: any) => 
      item.id === product.id && item.packageType === selectedPackage
    );
    
    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cart.push({ ...cartProduct, quantity });
    }
    
    localStorage.setItem('cart', JSON.stringify(cart));
    setCartCount(cart.reduce((sum: number, item: any) => sum + item.quantity, 0));
    window.dispatchEvent(new Event('storage'));
    
    // Show success message
    setShowAddedMessage(true);
    setTimeout(() => setShowAddedMessage(false), 2000);
  };

  const relatedProducts = [
    {
      id: 5,
      name: 'Soma 350mg',
      price: 200.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20soma%20carisoprodol%20muscle%20relaxer%20tablets%20in%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=300&height=300&seq=5&orientation=squarish',
      link: '/products/soma-350mg'
    },
    {
      id: 115,
      name: 'Tapentadol 100mg',
      price: 300.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20tapentadol%20pain%20relief%20tablets%20in%20pharmaceutical%20blister%20pack%20on%20clean%20white%20background%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=300&height=300&seq=6&orientation=squarish',
      link: '/products/tapentadol-100mg'
    },
    {
      id: 10,
      name: 'Amoxicillin 500mg',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20amoxicillin%20antibiotic%20capsules%20in%20pharmaceutical%20blister%20pack%20on%20clean%20white%20background%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=300&height=300&seq=amox1&orientation=squarish',
      link: '/products/amoxicillin'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Success Message */}
      {showAddedMessage && (
        <div className="fixed top-4 right-4 bg-teal-600 text-white px-6 py-3 rounded-lg shadow-lg z-50 flex items-center">
          <i className="ri-check-line text-xl mr-2"></i>
          <span>Added to cart successfully!</span>
        </div>
      )}

      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-2xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</Link>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Home</Link>
              <Link to="/all-products" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Products</Link>
              <a href="/#contact" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Contact</a>
            </div>
            <div className="flex items-center space-x-4">
              <Link to="/cart" className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer relative">
                <i className="ri-shopping-cart-line text-xl"></i>
                <span className="absolute -top-1 -right-1 bg-teal-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{cartCount}</span>
              </Link>
              <Link to="/auth" className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                <i className="ri-user-line text-xl"></i>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Product Detail */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <img src={product.image} alt={product.name} className="w-full rounded-2xl shadow-lg object-cover object-top" />
            <div className="mt-6 bg-blue-50 border-2 border-blue-500 rounded-lg p-4">
              <div className="flex items-center">
                <i className="ri-flag-line text-blue-600 text-2xl mr-3"></i>
                <div>
                  <p className="font-bold text-blue-900">US to US Shipping</p>
                  <p className="text-sm text-blue-700">Fast domestic delivery</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className="text-sm text-teal-600 font-semibold mb-2">{product.category}</p>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">{product.name}</h1>
            <div className="flex items-center mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`${i < Math.floor(product.rating) ? 'ri-star-fill' : 'ri-star-line'} text-yellow-400 text-lg`}></i>
                ))}
              </div>
              <span className="ml-2 text-gray-600">({product.reviews} reviews)</span>
            </div>
            <p className="text-4xl font-bold text-gray-900 mb-6">${currentPackage.price}</p>

            <div className="mb-6">
              <h3 className="font-semibold text-gray-900 mb-3">Select Package</h3>
              <div className="grid grid-cols-3 gap-3">
                {Object.entries(packages).map(([key, pkg]) => (
                  <button
                    key={key}
                    onClick={() => setSelectedPackage(key)}
                    className={`p-4 rounded-lg border-2 transition-all cursor-pointer ${
                      selectedPackage === key
                        ? 'border-teal-600 bg-teal-50'
                        : 'border-gray-200 hover:border-teal-300'
                    }`}
                  >
                    <div className="text-lg font-bold text-gray-900">{pkg.pills} pills</div>
                    <div className="text-sm text-teal-600 font-semibold">${pkg.price}</div>
                  </button>
                ))}
              </div>
            </div>

            <div className="flex items-center gap-4 mb-6">
              <div className="flex items-center border border-gray-300 rounded-lg">
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <i className="ri-subtract-line"></i>
                </button>
                <span className="px-6 py-2 border-x border-gray-300">{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <i className="ri-add-line"></i>
                </button>
              </div>
              <button onClick={addToCart} className="flex-1 bg-teal-600 text-white px-8 py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer font-semibold">
                <i className="ri-shopping-cart-line mr-2"></i>
                Add to Cart
              </button>
            </div>

            <div className="flex items-center gap-4 text-sm text-gray-600 mb-6">
              <div className="flex items-center">
                <i className="ri-shield-check-line text-teal-600 mr-2"></i>
                <span>100% Genuine</span>
              </div>
              <div className="flex items-center">
                <i className="ri-truck-line text-teal-600 mr-2"></i>
                <span>Fast Shipping</span>
              </div>
              <div className="flex items-center">
                <i className="ri-lock-line text-teal-600 mr-2"></i>
                <span>Secure Payment</span>
              </div>
            </div>

            <div className="border-t pt-6">
              <h3 className="font-semibold text-gray-900 mb-3">Description</h3>
              <p className="text-gray-600 mb-4">{product.description}</p>
              <p className="text-sm text-gray-600"><strong>SKU:</strong> MED{product.id.toString().padStart(6, '0')}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</h3>
              <p className="text-gray-400">Your trusted partner in healthcare.</p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:text-teal-400 transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/all-products" className="hover:text-teal-400 transition-colors cursor-pointer">Products</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Categories</h4>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Sleep Aid</a></li>
                <li><a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Pain Relief</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Contact Info</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-phone-line mt-1 mr-2"></i>
                  <span>+1 (929) 268-8770</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-mail-line mt-1 mr-2"></i>
                  <span>sam4104t@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400">&copy; 2024 MediCare. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-teal-400 transition-colors cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
